import { Button } from "@/modern/components/ui/button-shadcn";
import { PenBox, Plus } from "lucide-react";

interface EmptyChecklistsStateProps {
  onOpenEditor: (isCreatingNew: boolean) => void;
}

export const EmptyChecklistsState = ({ onOpenEditor }: EmptyChecklistsStateProps) => {

  return (
    <div className="h-full flex-1 flex flex-col py-4">
      <div className="min-h-[12rem] h-full flex-1 flex flex-col items-center justify-center gap-3 rounded-2xl border border-dashed border-muted-foreground/30 bg-muted/40 p-4 text-center shadow-sm">
        <div className="mx-auto flex size-10 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
          <PenBox className="size-5" />
        </div>
        <div className="space-y-1">
          <h3 className="text-sm font-semibold text-foreground">No checklists yet</h3>
          <p className="text-xs text-muted-foreground">Create a checklist to track tasks, approvals, or punch items for this record.</p>
        </div>
        <Button onClick={() => onOpenEditor(true)} className="inline-flex items-center gap-2">
          <Plus className="size-4" />
          New Checklist
        </Button>
      </div>
    </div>
  );
};
